import React, { useState, useEffect, createContext, useContext  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../css/form.css';
import CreateProductType from "./create/createProductType";
import UpdateProductType from "./update/updateProductType";
import axios from "axios";
import { API } from "../../../services/api";
import {UserContext } from "../../../App";

axios.defaults.baseURL = API;
const ProductTypeContext = createContext();

function ProductType() {

  const {userID, showForm, setShowForm, setshowSubmenu} = useContext(UserContext);

  const [dataList, setDataList] = useState([]);
  const [showData, setShowData] = useState([]);
  const [data, setData] = useState([]);

  const [show, setShow] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);

  const handleCloseUpdate = () => setShowUpdate(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const Search = event => {
    const { value } = event.target;
    if(value){
      var results = [];
      results = dataList.filter((data) => {
          return data.ProductType.toLowerCase().includes(value.toLowerCase())
      });
      if (results) 
      setShowData(results);
      else 
      setShowData(dataList);
    } else 
    setShowData(dataList);
  }

  const openUpdate = (ProductTypeID, ProductType) => {
    var list = [];
    list.push({
      ProductTypeID: ProductTypeID,
      ProductType: ProductType
    });
    setData(list);
    setShowUpdate(true);
  };

  async function getAllProductType() {
    axios
      .get("/getAllProductType")
      .then((response) => {
        let Data = response?.data;
        setDataList(Data);
        setShowData(Data);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  
  const handleclickBack = () => {
      setShowForm(false);
      setshowSubmenu(true);
  };
  

  useEffect(() => {
    getAllProductType();
  }, []);

  return (
    <ProductTypeContext.Provider value={{dataList, setDataList, data, setShowData}}>
      <div className="formContent">
        <CreateProductType show={show} onClick={handleClose}/>
        <UpdateProductType show={showUpdate} onClick={handleCloseUpdate}/>
        <div className="formCard">
        <div className="Header">
          <div className="title">
              <span>ຂໍ້ມູນ ປະເພດສິນຄ້າ</span>
          </div>
          <div className="buttonContent">
              <button className="btn btn-primary" onClick={handleShow} >ເພີ່ມ</button>
              <button className="btn btn-danger" onClick={() => handleclickBack()} >Back</button>
          </div>

        </div>
        <div className="Body">
          <div className="txtSearch">
            <input placeholder="ຄົ້ນຫາ" onChange={(e) => Search(e)} />
          </div>
          <table className="styled-table">
            <thead>
              <tr key={1}>
                <th>ລ/ດ</th>
                <th>ປະເພດສິນຄ້າ</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
                showData && showData.map((x, y) => {
                    return (
                      <tr key={y}>
                        <td >{y + 1}</td>
                        <td >{x.ProductType}</td>
                        <td >
                          <button className="btn btn-secondary" value={x.ProductTypeID} type="button" onClick={() => openUpdate(x.ProductTypeID, x.ProductType)}>ແກ້ໄຂ</button>
                        </td>
                      </tr>
                    )
                })
              }
            </tbody>
          </table>
        </div>
        </div>
      </div>
    </ProductTypeContext.Provider>
  );
};

export {ProductTypeContext};
export default ProductType;
